<template>
    <div></div>
</template>

<script>
import {verifyAccount} from "@/scripts/auth-utils";

export default {
    mounted() {
        const token = this.$route.params.token;
        this.activateAccount(token);
    },
    methods: {
        async activateAccount(token) {
            let response;
            try {
                response = await verifyAccount(token)
            } catch (e) {
                console.error('Activation request error', e);
                //todo: track this error
                await this.$router.push('/login?activation-code=1');
                return;
            }

            const data = response?.data?.verifyAccount;
            if (data?.success) {
                await this.$router.push('/feed');
            } else if (data?.errors) {
                console.error('Activation response error', data.errors);
                //todo: track this error
                await this.$router.push('/login?activation-code=' + this.getErrorMessage(data.errors));
            } else {
                console.error('Unknown error');
                //todo: track this error
                await this.$router.push('/login?activation-code=Unknown error');
            }
        },

        getErrorMessage(responseErrors) {
            let messages = [];
            if (typeof responseErrors !== 'object') {
                return 'Unknown error';
            }
            Object.keys(responseErrors).forEach((key) => {
                responseErrors[key].forEach((error) => {
                    if (error?.message) {
                        messages.push(error.message);
                    }
                });
            });
            return messages.join(', ');
        }
    }
}
</script>
